import { ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-audit-details-note-modal',
  templateUrl: './audit-details-note-modal.component.html',
  styleUrls: ['./audit-details-note-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailsNoteModalComponent implements OnInit {

  @Input() leftDiscrepancyToAdjust: number;
  @Input() noteDetails: any;

  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() submit: EventEmitter<{adjustmentQty: number, noteDescription: string}> = new EventEmitter();

  @ViewChild('adjustmentInput') adjustmentInput;
  @ViewChild('closeButton') closeButton;
  @ViewChild('submitButton') submitButton;

  adjustmentQtyInvalid: boolean = true;
  adjustmentQtyEmpty: boolean = true;

  adjustmentQty: number;
  noteDescription: string;

  constructor() { }

  ngOnInit(): void {
  }

  submitAdjustment(): void {
    this.submit.emit({adjustmentQty: this.adjustmentQty, noteDescription: this.noteDescription});
  }

  noteAdjustmentQtyChanged(qty: number): void {
    const quantity = +qty;
    if(quantity === 0) {
      this.adjustmentQtyInvalid = true;
      this.adjustmentQtyEmpty = true;
    } else {
      this.adjustmentQtyInvalid = +quantity > this.leftDiscrepancyToAdjust || quantity < 0;
      this.adjustmentQtyEmpty = false;
    }

    this.adjustmentQty = qty;
  }

  noteDescriptionChanged(descr: string): void {
    this.noteDescription = descr;
  }

  discrepancyExplainationTextAreaTabKeyPressed() {
    if (this.submitButton.disabled) {
      this.closeButton.focus();
    } else {
      this.submitButton.focus();
    }
  }

  focusAdjustmentInput() {
    this.adjustmentInput.focusInput();
  }

}
